export enum SettingsTabId {
   General = 'general',
   Header = 'header',
   Footer = 'footer',
   Theme = 'theme',
   CategoryImages = 'category-images',
   MediaLibrary = 'media-library',
   Sollicitants = 'sollicitants',
}

export interface SettingsTab {
   id: string;
   i18n_key: string;
}

export const tabs: SettingsTab[] = [
   {
      id: SettingsTabId.General,
      i18n_key: 'job-board.settings.general',
   },
   {
      id: SettingsTabId.Header,
      i18n_key: 'job-board.settings.header',
   },
   {
      id: SettingsTabId.Footer,
      i18n_key: 'job-board.settings.footer',
   },
   {
      id: SettingsTabId.Theme,
      i18n_key: 'job-board.settings.theme.theme',
   },
   {
      id: SettingsTabId.CategoryImages,
      i18n_key: 'job-board.settings.category-images.title',
   },
   {
      id: SettingsTabId.MediaLibrary,
      i18n_key: 'media-library.title',
   },
   {
      id: SettingsTabId.Sollicitants,
      i18n_key: 'job-board.settings.sollicitants.title',
   },
];
